import { createFileRoute } from '@tanstack/react-router';

import { PlanLibraryScreen, validatePlanLibrarySearch } from '~/pages/plan-library';

export const Route = createFileRoute('/_shell/plans/')({
  // Which parameters this screen understands is the SLICE's decision, so the validator is exported
  // from it: a route file is a wiring declaration, and anything a second route could want does not
  // live here. Today that is `?zakres=klienci`, and no parameter means the templates.
  validateSearch: validatePlanLibrarySearch,
  component: PlanLibraryScreen,
});
